import React from 'react';
import styles from './PollingStatus.module.css';

interface PollingStatusProps {
  attempts: number;
  phase: 'fast' | 'slow' | 'idle';
  elapsedTime?: number;
  maxAttempts?: number;
}

export function PollingStatus({ attempts, phase, elapsedTime, maxAttempts }: PollingStatusProps) {
  const formatTime = (ms: number) => {
    const seconds = Math.floor(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    
    if (minutes > 0) {
      return `${minutes}m ${remainingSeconds}s`;
    }
    return `${seconds}s`;
  };
  
  const getPhaseLabel = () => {
    switch (phase) {
      case 'fast':
        return 'Checking frequently...';
      case 'slow':
        return 'Checking periodically...';
      case 'idle':
        return 'Not checking';
      default:
        return '';
    }
  };
  
  const getPhaseColor = () => {
    switch (phase) {
      case 'fast':
        return styles.phaseFast;
      case 'slow':
        return styles.phaseSlow;
      case 'idle':
        return styles.phaseIdle;
      default:
        return '';
    }
  };
  
  if (phase === 'idle') {
    return null;
  }
  
  return (
    <div className={styles.container}>
      <div className={styles.progressBar}>
        <div 
          className={`${styles.progressFill} ${getPhaseColor()}`}
          style={{
            width: maxAttempts 
              ? `${(attempts / maxAttempts) * 100}%` 
              : '100%'
          }}
        />
      </div>
      
      <div className={styles.info}>
        <div className={styles.phase}>
          <span className={`${styles.phaseIndicator} ${getPhaseColor()}`} />
          {getPhaseLabel()}
        </div>
        
        <div className={styles.stats}>
          <span>Attempt {attempts}</span>
          {elapsedTime !== undefined && (
            <>
              <span className={styles.separator}>•</span>
              <span>{formatTime(elapsedTime)}</span>
            </>
          )}
        </div>
      </div>
    </div>
  );
}